const styles = (theme) => ({
  title: {
    color: theme.palette.common.blue400,
    width: '100%',
    fontSize: theme.typography.fontSize32,
    lineHeight: 1.6,
  },
  description: {
    lineHeight: 1.6,
    color: theme.palette.common.grey500,
    fontSize: theme.typography.fontSize16,
    '@media(max-width: 600px)': {
      fontSize: theme.typography.fontSize14,
    },
  },
  item: {
    '&:not(:first-of-type)': {
      marginTop: 10,
    },
  },
  link: {
    textDecoration: 'underline',
    cursor: 'pointer',
    color: 'unset',
  },
});

export default styles;
